import { ua } from '@/utils/util'

// https://mp.weixin.qq.com/s/FQpay-yc3RSsMkg1tq-FyA
// 这里处理ios端的软键盘弹出时，fixed元素定位问题，解决办法为上方链接中的方案三，即在软键盘弹出时，监听滚动事件，当滚动时，收起软键盘，解绑滚动事件，这样就可以避免软键盘弹出时，fixed元素定位问题。

export default function useFixScroll() {
  if (!ua.isiOS()) return
  const page: HTMLInputElement | null = document.querySelector('#app')
  let currentInput: HTMLInputElement | null = null // 当前聚焦的输入框
  const fixedEle = document.querySelector('.van-nav-bar') as HTMLElement | null

  // webview发生平移，则及时更新fixed元素的定位
  function handleScroll() {
    if (fixedEle) {
      fixedEle.style.top = `${window.pageYOffset}px`
    }
  }

  // 滚动时收起软键盘
  function stopMove() {
    if (currentInput) {
      currentInput.blur()
      currentInput = null
      window.removeEventListener('touchmove', stopMove)
      window.removeEventListener('scroll', handleScroll)

      if (fixedEle) {
        fixedEle.style.top = '0'
      }
    }
  }

  function handleFocusin(e: FocusEvent) {
    const target = e.target as HTMLInputElement

    if (!target || !target.name || target.tagName !== 'INPUT') return
    // 在本身有输入框处于聚焦状态软键盘出现时，点击聚焦另外的输入框
    if (currentInput) {
      currentInput = target
      return
    }
    // 添加滚动监听，为了软键盘出现 以及 从一个聚焦输入框聚焦到另外一个输入框时， 重新定位fixed元素（其实这里不用滚动事件监听变化也可以用setTimeout来更新定位）
    window.addEventListener('scroll', handleScroll)
    currentInput = target
    // 监听移动手势：
    // 1. 在软键盘出现后，如果想要滚动，则收起软键盘，解绑webview的滚动监听事件
    // 2. 在软键盘出现后，用户主动收起软键盘（如点击软键盘的收起/完成等按钮），此时用户没有做移动手势，那么就会在收起软键盘后只要做了移动手势，就仍然触发绑定事件，达到解绑滚动监听事件的目的，阻止监听到webview回弹效果导致的固定顶部元素发生位移。
    window.addEventListener('touchmove', stopMove)
  }

  page && page.addEventListener('focusin', handleFocusin)
}
